<script setup lang="ts">
  import { FlowQuoteWidget } from '@/widgets/Flow'
  interface Emits {
    (e: 'back'): void
  }
  const emit = defineEmits<Emits>()
  const onEditTravelers = () => {
    emit('back')
  }
</script>

<template>
  <FlowQuoteWidget @edit-travelers="onEditTravelers" />
</template>
